// extracted by mini-css-extract-plugin
module.exports = {"arrows":"QuoteTermsArrows_arrows__3m7wL"};